export const LOAD_MORPHEUS_SETTING = 'LOAD_MORPHEUS_SETTING';
export const UPDATE_MORPHEUS_SETTING = 'UPDATE_MORPHEUS_SETTING';
